// Polish locale for every flatpickr instance (locale: "pl").
import flatpickr from "flatpickr"
import { Polish } from "flatpickr/dist/l10n/pl.js"

flatpickr.l10ns.pl = Polish
flatpickr.localize(Polish)
